@for (cc of contactContainers$ | async; track cc.contactId) {
  <div class="container">
    @if (cc.contact) {
      <meeting-analysis-participant [contact]="cc.contact" [large]="large()"></meeting-analysis-participant>
    } @else {
      <meeting-analysis-attendee
        [user]="null"
        [large]="large()"
        defaultInformationKey="MEETING_DETAILS.CONTACT_NOT_AVAILABLE"
      ></meeting-analysis-attendee>
    }
  </div>
}
